export class ArchivoCargueAdminInfI{
  nombre : String;
	comentario : String;
	tipo : String;
	fechaCarga : String;
	rutaArch : String;
	contenido : String;
	idUsuarioCarga : Number;
	idFuente : BigInteger;
	idPeriodo : BigInteger;
}
